export type SnapshotId = string; // vCollect._key from Arango collection vCollect

export type WithSnapshot = {
  snapshot: SnapshotId;
};

export const untitledSnapshotName = 'Snapshot';
